import { Button, ButtonGroup, Flex, Text } from '@lego/klik-ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  backAction?: {
    label: string;
    to: string;
  };
  onRetry: () => Promise<unknown>;
};

export const PageLoadError = ({ backAction, onRetry }: Props) => {
  const navigate = useNavigate();
  const [isRetrying, setIsRetrying] = useState(false);

  const handleRetry = async () => {
    setIsRetrying(true);
    try {
      await onRetry();
    } catch {
      // The data hook displays the API error toast.
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <Flex
      alignItems="center"
      direction="column"
      gap={4}
      justifyContent="center"
      minHeight="240px"
      textAlign="center"
    >
      <Text as="h2" fontSize="xl" fontWeight="bold">
        Unable to load this page
      </Text>
      <Text color="slate.600" maxWidth="480px">
        {backAction
          ? 'The requested data could not be loaded. Try again, or return to a page where you can continue working.'
          : 'The requested data could not be loaded. Try again to continue working.'}
      </Text>
      <ButtonGroup>
        <Button isLoading={isRetrying} onClick={handleRetry}>
          Try again
        </Button>
        {backAction && (
          <Button onClick={() => navigate(backAction.to)} variant="outline">
            {backAction.label}
          </Button>
        )}
      </ButtonGroup>
    </Flex>
  );
};
